import * as tslib_1 from "tslib";
import { makePatchRequest } from 'owa-ows-gateway';
import { format } from 'owa-strings';
var UNSUBSCRIBE_URL = 'ows/api/beta/subscriptions/{0}/unsubscribe';
function unsubscribeFromBrandSubscriptionService(smtpIdentifier, unsubscribeSilentUris) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makePatchRequest(format(UNSUBSCRIBE_URL, smtpIdentifier), {
                        unsubscribeSilentUris: unsubscribeSilentUris,
                    }, null, true)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export default unsubscribeFromBrandSubscriptionService;
//# sourceMappingURL=unsubscribeFromBrandSubscriptionService.js.map